<ion-grid>
  <ion-row>
    <ion-col size-xs="12">
      <span style="color: var(--ion-color-primary); font-weight: 700; font-size: 18px;">{{ toolTipTitle }} Definition</span>
    </ion-col>
  </ion-row>
  <ion-row class="ion-text-left">
    <ion-col size="12" class="responsive-font-size ion-align-self-center">
      <div *ngFor="let toolTipDetail of toolTipDetails">
        <p>{{ toolTipDetail }}</p> 
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size-xs="12" style="margin-bottom: 10px;">
      <span style="color: white; font-weight: 700; font-size: 18px;">Mask Image Examples</span>
    </ion-col>
  </ion-row>
  <ion-row class="ion-no-padding ion-align-items-center" *ngFor="let mask of configDataService.MASK_CLASS">
    <ion-col class="ion-no-padding ion-text-center" style="color: white; font-weight: 600;" size-xs="3">
      {{ mask }}
    </ion-col>
    <ion-col size-xs="3" class="ion-align-items-center">
      <div class="grid-image-container">
        <img class="grid-image" [src]="getImageSrc(mask, 1)"/>
      </div>
    </ion-col>
    <ion-col size-xs="3" class="ion-align-items-center">
      <div class="grid-image-container">
        <img class="grid-image" [src]="getImageSrc(mask, 2)"/>
      </div>
    </ion-col>
    <ion-col size-xs="3" class="ion-align-items-center">
      <div class="grid-image-container">
        <img class="grid-image" [src]="getImageSrc(mask, 3)"/>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>